import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import SellUsedCarSeo from "./component";
import { setFirstLoad } from "../../../components/configuration/actions";
import { updateLeadSource } from "../../../components/desktop/settings/actions";
import { selectCity } from "../cities/actions";
import { resetLeadFormData, setData, setStep } from "../../../components/desktop/lead-form/actions";
import { fetchData } from "../../../components/shared/meta-tags/actions";

const mapStateToProps = ({
    meta: { templateType, identifiers, status, isSSR, mainHeading, faqList },
    config: { cityList },
    user: { isFirstLoad },
    brands: { all: allBrands },
    seoModels: { all: allModels },
    sellUsedCar: { nearestCities, hubsAndParkingYards },
    ratedTestimonials: { list },
    footer: {
        data: {
            top_cities: topCitiesList
        }
    },
    experiments: {
        statsigDynamicConfig: {
            data: statsigDynamicConfigData
        },
        websiteAdvertisementBanner: {
            data: websiteAdvertisementBannerData
        }
    }
}) => ({
    list,
    identifiers,
    templateType,
    allBrands,
    allModels,
    cityList,
    status,
    isFirstLoad,
    nearestCities,
    hubsAndParkingYards,
    isSSR,
    mainHeading,
    faqList,
    topCitiesList,
    statsigDynamicConfigData,
    websiteAdvertisementBannerData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    selectCityConnect: selectCity,
    resetLeadFormDataConnect: resetLeadFormData,
    setFirstLoadConnect: setFirstLoad,
    updateLeadSourceConnect: updateLeadSource,
    setDataConnect: setData,
    setStepConnect: setStep,
    fetchDataConnect: fetchData
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SellUsedCarSeo));
